<!-- Subscription invoice form -->
<div class="invoice-child" [ngClass]="theme.getThemeClass()">
  @if (isBusy) {
    <div class="invoice-loading-overlay">
      <div class="loading-inline">{{ "loading" | translate }}</div>
    </div>
  }
  <h5 class="invoice-title">
    {{ "invoiceGeneration.subscription" | translate }}
  </h5>

  <!-- Invoice fields -->
  <div class="invoice-fields">
    <app-invoice-device-count-info
      [deviceCount]="deviceCount"
      [devices]="selectedDeviceDetails"
    ></app-invoice-device-count-info>

    <div class="form-group">
      <!-- Billing period range -->
      <label class="form-label">{{ "invoicePdf.period" | translate }}</label>
      <div class="period-row">
        <input class="form-control" type="date" [(ngModel)]="periodStart" />
        <span class="period-separator">→</span>
        <input class="form-control" type="date" [(ngModel)]="periodEnd" />
      </div>
    </div>

    <div class="form-group">
      <!-- Per-device subscription fee -->
      <label class="form-label">{{
        "costEdit.subscriptionFee" | translate
      }}</label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="subscriptionFee"
          (input)="feeInput.onInput($event)"
          (keydown)="feeInput.onKeydown($event)"
          (paste)="feeInput.onPaste($event)"
          (blur)="subscriptionFee = feeInput.formatFeeValue(subscriptionFee)"
        />
      </div>
    </div>

    <div class="form-group">
      <!-- Flat service fee -->
      <label class="form-label">{{ "costEdit.serviceFee" | translate }}</label>
      <div class="input-group">
        <span class="input-group-text">$</span>
        <input
          class="form-control"
          type="text"
          [(ngModel)]="serviceFee"
          (input)="feeInput.onInput($event)"
          (keydown)="feeInput.onKeydown($event)"
          (paste)="feeInput.onPaste($event)"
          (blur)="serviceFee = feeInput.formatFeeValue(serviceFee)"
        />
      </div>
    </div>
    <!-- PDF generation action -->
    <div class="actions">
      <div class="actions-inner">
        <button
          class="btn btn-dropdown fixed-size"
          type="button"
          [disabled]="!canGenerate"
          (click)="generateInvoicePdf()"
        >
          {{ "invoiceGeneration.generate" | translate }}
        </button>
      </div>
    </div>
  </div>

</div>
